import app from './app';
app();
